var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOdg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1604 12C0.160401 5.37261 5.53298 2.99382e-05 12.1604 3.05176e-05L12.1604 4.00003C7.74211 4.00003 4.16039 7.58175 4.16039 12C4.16039 16.4183 7.74211 20 12.1604 20V24C5.53298 24 0.160399 18.6274 0.1604 12Z",
    fill: "#459D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1604 12C24.1604 18.6274 18.7878 24 12.1604 24V20C16.5787 20 20.1604 16.4183 20.1604 12C20.1604 7.58175 16.5787 4.00003 12.1604 4.00003V3.05176e-05C18.7878 3.05176e-05 24.1604 5.37261 24.1604 12Z",
    fill: "#7DD03C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1604 15.9999C14.3695 15.9999 16.1603 14.2091 16.1603 12C16.1603 9.79086 14.3695 8.00002 12.1604 8.00002V15.9999Z",
    fill: "#459D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1604 8.00013C9.95128 8.00013 8.16044 9.79096 8.16044 12.0001C8.16044 14.2092 9.95128 16 12.1604 16L12.1604 8.00013Z",
    fill: "#7DD03C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdg);
export default __webpack_public_path__ + "static/media/odg.d62e3599acb71a1f784207f32ba6adab.svg";
export { ForwardRef as ReactComponent };